import {makeThemeProps} from "@themes/default/props/utils";

export default (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getSortFiltersProps(theme);
};
